import React from 'react';
import PropTypes from 'prop-types';
import AsyncReactSelect from 'react-select/async';

import './style.scss';
import { ControlWithTestId, OptionWithTestId, styles } from '.';

const AsyncSelect = React.forwardRef((props, ref) => {
  const {
    label,
    id,
    className,
    menuPositionFixed = true,
    clearValueAfterSelection = false,
    getLabel,
    value,
    cacheOptions = true,
    inputId,
    ...otherProps
  } = props;

  return (
    <>
      <label htmlFor={id} className="visuallyhidden">
        {label}
      </label>
      <AsyncReactSelect
        id={id}
        ref={ref}
        className={`${className || ''} react-select-container`}
        classNamePrefix="react-select"
        onChange={props.onChange}
        unstyled
        styles={styles}
        menuPosition={menuPositionFixed ? 'fixed' : 'absolute'}
        menuPortalTarget={menuPositionFixed ? document.body : undefined}
        getOptionLabel={getLabel}
        value={value ? value : clearValueAfterSelection ? '' : undefined}
        isDisabled={props.disabled}
        inputId={inputId || `${id}-input`}
        components={{ Option: OptionWithTestId, Control: ControlWithTestId }}
        {...otherProps}
      />
    </>
  );
});

export default AsyncSelect;

AsyncSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  menuPositionFixed: PropTypes.bool,
  loadOptions: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  cacheOptions: PropTypes.bool,
  defaultOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.any,
    }),
  ),
  clearValueAfterSelection: PropTypes.bool,
};


